<span {{#unless sr_caption}}aria-hidden="true"{{/unless}} data-action-target="icon"
  {{!-- will be removed, this is for tab legacy icons --}}
  {{#if iconTab}}
    {{#if index }}
      data-icon="{{uuid}}-{{index}}-{{prefix}} {{name}}"
    {{else}}
      data-icon="{{uuid}}-{{prefix}} {{name}}"
    {{/if}}
  {{/if}}
  {{!-- *** --}}
  {{#if icon}}
    {{#if index }}
      data-icon="{{uuid}}-{{index}}-{{icon}}"
    {{else}}
      data-icon="{{uuid}}-{{icon}}"
    {{/if}}
  {{else}}
    {{#if layer_icons}}
      {{#if index }}
        id="{{uuid}}-{{index}}"
      {{else}}
        id={{uuid}}
      {{/if}}
    {{else}}
      {{#if index }}
        data-icon="{{uuid}}-{{index}}-{{prefix}} {{name}}"
      {{else}}
        data-icon="{{uuid}}-{{prefix}} {{name}}"
      {{/if}}
    {{/if}}
  {{/if}}
  {{#if styles}}
    {{#with styles}}
    data-fa-transform="{{faTransform 'flip' flip}} {{faTransform 'rotate' rotate}} {{faTransform 'horizontal' horizontal}} {{faTransform 'vertical' vertical}} {{faTransform 'scale' scale}}"
    {{/with}}
  {{/if}}
    class="{{classes}}"
  {{#if sr_caption}}
    title="{{sr_caption}}"
  {{/if}}>
  {{~#if sr_caption}}
    <span class="screen-reader-content">
      {{t sr_caption}}
    </span>
  {{/if~}}
</span>